<div class="informes">
    <h2 style="text-align: center;">GESTION DE INFORMES</h2>
    <div class="row" style="margin-left:10px; margin-top: 10px;">
        <div class="col-3">
            <ng-container *ngIf="user.rol.includes('admin')">
                <button mat-button color="primary" [routerLink]="['/informe-fabrica','nuevo','']"><mat-icon>add</mat-icon>NUEVO INFORME DE FÁBRICA</button>
                <button mat-button color="primary" [routerLink]="['/informe-mae','nuevo','']"><mat-icon>add</mat-icon>NUEVO INFORME DE MAE</button>
            </ng-container>
    </div>
    <div class="col-6">
    <table border=1 style="text-align: center;">
        <tr>
            <td style="width:30%">
                <strong>Valores para el informe</strong>
            </td>
            <td style="width:15%">
                <span><b>AÑO:</b></span>
            </td>
            <td style="width:15%">
                <input *ngIf="fecha" type="text" [(ngModel)]="ano">
                <span *ngIf="!fecha">{{ano}}</span>
            </td>
            <td style="width:15%">
                <span><b>MES:</b></span>
            </td>
            <td style="width: 15%">
                <input *ngIf="fecha" type="text" [(ngModel)]="mes">
                <span *ngIf="!fecha">{{mes}}</span>
            </td>
            <td style="width:10%">
                <button mat-button color="primary" (click)="editFecha()">
                    <mat-icon>edit</mat-icon>
                </button>
            </td>
        </tr>
    </table>
    </div>
    </div>

<mat-tab-group class="alarm-type-tabs">
    <mat-tab *ngFor="let c of reportCodes;" label="Informes de {{c | getToTitle}}"> 
        <ng-template matTabContent>
            <app-informes-tables [codigoFilter]="c" [user]="user" [year]="ano" [month]="mes"></app-informes-tables> 
        </ng-template>
    </mat-tab>
</mat-tab-group>

